import * as t from 'io-ts'

import { Activity, TargetGroup } from '@espoon-voltti/nuora-domain/applicants'

export { NuoraOrg as NuoraOrgDto } from '@espoon-voltti/nuora-domain/applicants'

export const DraftNuoraOrgDto = t.type({
  activity: t.union([Activity, t.null]),
  targetGroup: t.union([TargetGroup, t.null]),
  members: t.type({
    from7to20: t.union([t.number, t.null]),
    from21to28: t.union([t.number, t.null]),
    from29: t.union([t.number, t.null])
  })
})
export type DraftNuoraOrgDto = t.TypeOf<typeof DraftNuoraOrgDto>
